import { Pipe, PipeTransform } from '@angular/core';
import { RpaDto } from '@flyfreely-portal-ui/flyfreely';

@Pipe({ name: 'rpaStatusBlock' })
export class RpaStatusBlockPipe implements PipeTransform {
    transform(status: RpaDto.Status) {
        switch (status) {
            case RpaDto.Status.SERVICEABLE:
                return 'active';
            case RpaDto.Status.UNSERVICEABLE:
                return 'inactive';
            case RpaDto.Status.RETIRED:
                return 'disabled';
            case RpaDto.Status.UNDER_MAINTENANCE:
                return 'pending';
            default:
                return `disabled`;
        }
    }
}
